import { ENTITY_LISTING_VIEW_TYPE } from '../../../../../constants/common'

import {
  VIEWING_VIEW_TYPES,
  VIEWINGS_VIEW_PARAM,
} from './useRentalPortalViewingsViewRegime.constants'

export function getViewingsViewRegime(searchParams) {
  const view = searchParams.get(VIEWINGS_VIEW_PARAM)

  return VIEWING_VIEW_TYPES.includes(view)
    ? view
    : ENTITY_LISTING_VIEW_TYPE.table
}
